import React, { Component } from 'react'
import video from '../img/Country_Neighbors.mp4'
import videoWebm from '../img/Country_Neighbors.webm'
import bgImage from '../static/img/placeholder.jpeg'

class HomepageVideo extends Component {
  componentDidMount() {
    setTimeout(() => {
      // document.getElementById('video').muted = false
      document.getElementById('video').play()
    }, 1000)
  }

  render() {
    return (
      <div style={{ textAlign: 'center' }}>
        <video
          id="video"
          controls
          autoplay
          muted
          style={{
            width: '100%',
            // border: '3px solid black'
          }}
          poster={bgImage}
        >
          <source src={video} type="video/mp4" />
          <source src={videoWebm} type="video/webm" />
          <p>
            Your browser doesn't support HTML5 video. Here is a{' '}
            <a href={video}>link to the video</a> instead.
          </p>
        </video>
      </div>
    )
  }
}

export default HomepageVideo



// WEBPACK FOOTER //
// ./src/components/HomepageVideo.js